/* eslint-disable react/jsx-fragments */
import React, { useEffect, useState } from 'react';
import Loading from 'components/loading/Loading';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Card, Row } from 'react-bootstrap';
import { formatDate } from 'helpers.js';

import { aggiornaCalendario } from 'features/bi/biSlice';
import ExcelExport from 'components/export/ExcelExport';
import { getData } from './functions';

const StabCountry = () => {
  const { caricamentoInCorso, bi, calendario } = useSelector((state) => state.bi);

  useEffect(getData, [calendario]);
  const [changed, setChanged] = useState(false);
  const [temp, setTemp] = useState('');

  const dispatch = useDispatch();

  if (caricamentoInCorso) {
    return <Loading />;
  }

  function getMeseHeader(cal, onlyYear = false) {
    cal = cal.split('/').reverse().join('-');
    const c = new Date(cal);
    const month = c.toLocaleString('default', { month: 'long' });
    const year = c.getFullYear();
    if (onlyYear) {
      return `${year} / ${year - 1}`;
    }
    return `${month} ${year} / ${month} ${year - 1}`;
  }

  function formatNumber(n, percentuale = false) {
    if (!n) return '0';
    n = Number(n);
    if (percentuale) return `${n.toFixed(2).toString()}%`;
    return n
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '˙');
  }

  return (
    <Row>
      {/* Title Start */}
      <section className="scroll-section" id="title">
        <div className="page-title-container">
          <h1 className="mb-0 pb-0 display-4">Factory x Country</h1>
        </div>
      </section>
      <section className="scroll-section">
        <Card>
          <Card.Header>
            <Card.Header className="d-flex justify-content-between w-100">
              <Card.Title> </Card.Title>
              <ExcelExport idTabella="tabella-stabcountrybi" />
            </Card.Header>
            <input
              type="date"
              className="form-control me-2"
              value={temp ? temp.split('/').reverse().join('-') : calendario.split('/').reverse().join('-')}
              onChange={(e) => {
                const ladataBella = formatDate(new Date(e.target.value), 'dd/mm/yyyy');
                setChanged(true);
                setTemp(ladataBella);
              }}
            />
            <Button
              hidden={!changed}
              onClick={() => {
                dispatch(aggiornaCalendario(temp));
                setTemp('');
                setChanged(false);
              }}
            >
              Conferma
            </Button>
          </Card.Header>
          <Card.Body>
            <div className="table-responsive-md">
              <table id="tabella-stabcountrybi" className="table  table-bordered table-striped table-hover">
                <thead className="table-primary">
                  <tr>
                    <th>Impianto</th>
                    <th>Spedizioni</th>
                    <th>{getMeseHeader(calendario)}</th>
                    <th>%</th>
                    <th>{getMeseHeader(calendario, true)}</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Modugno */}
                  <tr>
                    <th scope="row">Modugno</th>
                    <td>
                      {/* IT: Kg. {bi?.modugnoItalia?.AnnoCorrente} <br /> ES: Kg. {bi?.modugnoEstero?.AnnoCorrente} */}
                      IT: <br /> estero:
                    </td>
                    <td>
                      Kg. {bi?.modugnoItalia?.MeseCorrente} / Kg. {bi?.modugnoItalia?.MeseScorso} <br /> Kg. {bi?.modugnoEstero?.MeseCorrente} / Kg.{' '}
                      {bi?.modugnoEstero?.MeseScorso}
                    </td>
                    <td>
                      {formatNumber((bi?.modugnoItalia?.MeseCorrente * 100) / bi?.modugnoItalia?.MeseScorso, true)} <br />
                      {formatNumber((bi?.modugnoEstero?.MeseCorrente * 100) / bi?.modugnoEstero?.MeseScorso, true)} <br />
                    </td>
                    <td>
                      Kg. {formatNumber(bi?.modugnoItalia?.AnnoCorrente)} / Kg. {formatNumber(bi?.modugnoItalia?.AnnoScorso)} <br /> Kg.{' '}
                      {formatNumber(bi?.modugnoEstero?.AnnoCorrente)} / Kg.
                      {formatNumber(bi?.modugnoEstero?.AnnoScorso)}
                    </td>
                    <td>
                      {formatNumber((bi?.modugnoItalia?.AnnoCorrente * 100) / bi?.modugnoItalia?.AnnoScorso, true)}
                      <br />
                      {formatNumber((bi?.modugnoEstero?.AnnoCorrente * 100) / bi?.modugnoEstero?.AnnoScorso, true)}
                    </td>
                  </tr>

                  {/* Coseano */}
                  <tr>
                    <th scope="row">Coseano</th>
                    <td>
                      IT: <br /> estero:
                    </td>
                    <td>
                      Kg. {formatNumber(bi?.coseanoItalia?.MeseCorrente)} / Kg. {formatNumber(bi?.coseanoItalia?.MeseScorso)} <br /> Kg.{' '}
                      {formatNumber(bi?.coseanoEstero?.MeseCorrente)} / Kg. {bi?.coseanoEstero?.MeseScorso}
                    </td>
                    <td>
                      {formatNumber((bi?.coseanoItalia?.MeseCorrente * 100) / bi?.coseanoItalia?.MeseScorso, true)} <br />
                      {formatNumber((bi?.coseanoEstero?.MeseCorrente * 100) / bi?.coseanoEstero?.MeseScorso, true)} <br />
                    </td>
                    <td>
                      Kg. {formatNumber(bi?.coseanoItalia?.AnnoCorrente)} / Kg. {formatNumber(bi?.coseanoItalia?.AnnoScorso)} <br /> Kg.{' '}
                      {formatNumber(bi?.coseanoEstero?.AnnoCorrente)} / Kg. {formatNumber(bi?.coseanoEstero?.AnnoScorso)}
                    </td>
                    <td>
                      <td>
                        {formatNumber((bi?.coseanoItalia?.AnnoCorrente * 100) / bi?.coseanoItalia?.AnnoScorso, true)}
                        <br />
                        {formatNumber((bi?.coseanoEstero?.AnnoCorrente * 100) / bi?.coseanoEstero?.AnnoScorso, true)}
                      </td>
                    </td>
                  </tr>

                  {/* totali */}
                  <tr>
                    <th scope="row">totali</th>
                    <td>
                      IT: <br /> estero:
                    </td>
                    <td>
                      Kg. {formatNumber(bi?.totaleItalia?.MeseCorrente)} / Kg. {formatNumber(bi?.totaleItalia?.MeseScorso)} <br /> Kg.{' '}
                      {formatNumber(bi?.totaleEstero?.MeseCorrente)} / Kg. {bi?.totaleEstero?.MeseScorso}
                    </td>
                    <td>
                      {formatNumber((bi?.totaleItalia?.MeseCorrente * 100) / bi?.totaleItalia?.MeseScorso, true)} <br />
                      {formatNumber((bi?.totaleEstero?.MeseCorrente * 100) / bi?.totaleEstero?.MeseScorso, true)}
                      <br />
                    </td>
                    <td>
                      Kg. {formatNumber(bi?.totaleItalia?.AnnoCorrente)} / Kg. {formatNumber(bi?.totaleItalia?.AnnoScorso)} <br /> Kg.{' '}
                      {formatNumber(bi?.totaleEstero?.AnnoCorrente)} / Kg. {formatNumber(bi?.totaleEstero?.AnnoScorso)}
                    </td>

                    <td>
                      {formatNumber((bi?.totaleItalia?.AnnoCorrente * 100) / bi?.totaleItalia?.AnnoScorso, true)}
                      <br />
                      {formatNumber((bi?.totaleEstero?.AnnoCorrente * 100) / bi?.totaleEstero?.AnnoScorso, true)}
                    </td>
                  </tr>

                  {/* share */}
                  <tr>
                    <th scope="row">Share</th>
                    <td>
                      Modugno:{' '}
                      {formatNumber((bi?.modugnoTotale?.AnnoCorrente * 100) / (bi?.modugnoTotale?.AnnoCorrente + bi?.coseanoTotale?.AnnoCorrente), true)}
                      <br />
                      Coseano:{' '}
                      {formatNumber((bi?.coseanoTotale?.AnnoCorrente * 100) / (bi?.modugnoTotale?.AnnoCorrente + bi?.coseanoTotale?.AnnoCorrente), true)}
                    </td>
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                  <tr>
                    <th scope="row">Share</th>
                    <td>
                      Italy: {formatNumber((bi?.totaleItalia?.AnnoCorrente * 100) / (bi?.totaleItalia?.AnnoCorrente + bi?.totaleEstero?.AnnoCorrente), true)}
                      <br />
                      estero: {formatNumber((bi?.totaleEstero?.AnnoCorrente * 100) / (bi?.totaleItalia?.AnnoCorrente + bi?.totaleEstero?.AnnoCorrente), true)}
                    </td>
                    <td />
                    <td />
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </section>
    </Row>
  );
};

export default StabCountry;
